// src/index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./app/routes";
import store from "./core/store/store";
import { Provider } from "react-redux";
import { ThemeProvider, GlobalStyles } from "@mui/material";
import theme from "./app/theme";
import CssBaseline from "@mui/material/CssBaseline";
import FerrariErrorBoundary from "./shared/components/FerrariErrorBoundary";
import "./index.css";
import './core/i18n/i18n';
import App from './app/App';

// Bulletproof patch to prevent "Failed to execute 'removeChild' on 'Node'" crashes in React 18
// This commonly occurs during logout or unmounting when browser extensions (like Google Translate)
// or strict mode animations have already modified/removed the DOM node.
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) console.warn("React tried to remove a child from a different parent, suppressed crash.", child);
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) console.warn("React tried to insert before a node with a different parent, suppressed crash.");
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const globalStyles = (
  <GlobalStyles
    styles={{
      "input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active":
        {
          WebkitBoxShadow: "0 0 0 1000px #1E1E1E inset !important",
          WebkitTextFillColor: "#E0E0E0 !important",
          transition: "background-color 5000s ease-in-out 0s",
        },
      ".MuiOutlinedInput-root:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 1000px #1E1E1E inset !important",
        WebkitTextFillColor: "#E0E0E0 !important",
      },
    }}
  />
);

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <FerrariErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {globalStyles}
        <Provider store={store}>
          <App />
        </Provider>
      </ThemeProvider>
    </FerrariErrorBoundary>
  </React.StrictMode>
);
